const STORAGE_KEY = 'holo/runtime/v1/client-runtime-id'
const STAGE_RUNTIME_ID = /^stage-[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

function requireStorage(storage) {
  if (!storage || typeof storage.getItem !== 'function' || typeof storage.setItem !== 'function')
    throw new TypeError('storage must implement getItem/setItem')
  return storage
}

export function isHoloClientRuntimeId(value) {
  return typeof value === 'string' && STAGE_RUNTIME_ID.test(value)
}

export function getOrCreateHoloClientRuntimeId({
  storage = globalThis.localStorage,
  randomUUID = globalThis.crypto?.randomUUID?.bind(globalThis.crypto),
} = {}) {
  const resolvedStorage = requireStorage(storage)
  const existing = resolvedStorage.getItem(STORAGE_KEY)
  if (isHoloClientRuntimeId(existing))
    return existing

  if (typeof randomUUID !== 'function')
    throw new Error('crypto.randomUUID is required to create client_runtime_id')

  const created = `stage-${randomUUID()}`
  if (!isHoloClientRuntimeId(created))
    throw new Error('randomUUID returned an invalid UUID')

  resolvedStorage.setItem(STORAGE_KEY, created)
  return created
}

export const HOLO_CLIENT_RUNTIME_STORAGE_KEY = STORAGE_KEY
